import { CardFieldEvent } from './CardFormWL.types';

export const VALIDATION_TIMEOUT = 3000;

export const getOldEvents = (validateFields: Map<string, CardFieldEvent>): CardFieldEvent[] => {
  const now = new Date();
  const threeSecondsAgo = now.getTime() - VALIDATION_TIMEOUT;

  return Array.from(validateFields.values()).filter(event => event.modifiedAt.getTime() < threeSecondsAgo);
};

export const getValidEvents = (validateFields: Map<string, CardFieldEvent>): CardFieldEvent[] =>
  Array.from(validateFields.values()).filter(event => event.isValid);
